import React from "react";
import { TbWorld } from "react-icons/tb";
import { FiTool } from "react-icons/fi";

const AllSiteSettingsIcon = ({ color = '#4088cf', stroke, size = 26 }) => {
  return (
    <div style={{ 
      position: "relative", 
      width: size, 
      height: size,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      {/* World icon as base */}
      <TbWorld
        style={{ 
          position: "absolute",
          fill: color,
          fontSize: size,
          strokeWidth: 1,
          stroke: stroke
        }} 
      />
      {/* Tool icon overlaid on bottom-right */}
      <FiTool 
        style={{ 
          position: "absolute",
          fill: color,
          fontSize: size * 0.5,
          right: 0,
          bottom: 0,
          transform: "translate(10%, 10%)",
          strokeWidth: 1,
          stroke: stroke
        }} 
      />
    </div>
  );
};

export default AllSiteSettingsIcon;
